import {
  FromToNumberInput,
  type FromToNumberInputProps,
} from "components/ui/FromToNumberInput";
import {
  type Control,
  type FieldPath,
  type FieldValues,
  useController,
} from "react-hook-form";

export type RhfFromToNumberInputProps<T extends FieldValues> = {
  nameFrom: FieldPath<T>;
  nameTo: FieldPath<T>;
  control?: Control<T>;
} & Omit<
  FromToNumberInputProps,
  "fromValue" | "toValue" | "onFromChange" | "onToChange"
>;

/**
 * React Hook Form アダプタ for FromToNumberInput。
 * @param {RhfFromToNumberInputProps<T>} props props
 * @return {JSX.Element} RHF 接続された FromToNumberInput
 */
export function RhfFromToNumberInput<T extends FieldValues>({
  nameFrom,
  nameTo,
  control,
  ...rest
}: RhfFromToNumberInputProps<T>): JSX.Element {
  const fromCtrl = useController<T>({ name: nameFrom, control });
  const toCtrl = useController<T>({ name: nameTo, control });

  return (
    <FromToNumberInput
      {...rest}
      fromValue={
        fromCtrl.field.value !== undefined && fromCtrl.field.value !== null
          ? Number(fromCtrl.field.value)
          : undefined
      }
      toValue={
        toCtrl.field.value !== undefined && toCtrl.field.value !== null
          ? Number(toCtrl.field.value)
          : undefined
      }
      onFromChange={fromCtrl.field.onChange}
      onToChange={toCtrl.field.onChange}
    />
  );
}
